import { render, staticRenderFns } from "./Obat.vue?vue&type=template&id=ebe8cbe6&"
import script from "./Obat.vue?vue&type=script&lang=js&"
export * from "./Obat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports